import React, { useState } from 'react';
import logo from '../../Assets/Logo1.png';
import './NavBar.css';

const NavBar = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className="h-[10vh] w-full flex items-center px-4 md:px-10 relative"   style={{padding: '20px'}}>

            {/* Logo */}
         <img 
  src={logo}
  alt="Logo"
  className="h-[15vh] w-auto object-contain"

/>



            {/* Desktop Menu */}
            <div className="hidden md:flex ml-auto font-semibold mt-2 mr-10 space-x-10">
                <button className="cta">
                    <a href="#landingPage">
                        <span className="hover-underline-animation">Home</span>
                    </a>
                </button>

                <button className="cta">
                    <a href="#Aboutus">
                        <span className="hover-underline-animation">About</span>
                    </a>
                </button>

                <button className="cta">
                    <a href="#Service">
                        <span className="hover-underline-animation">Services</span>
                    </a>
                </button>

                <button className="cta">
                    <a href="#blogs">
                        <span className="hover-underline-animation">Blogs</span>
                    </a>
                </button>
            </div>

            {/* Mobile Hamburger Icon */}
            <button
                className="md:hidden ml-auto focus:outline-none"
                onClick={() => setOpen(!open)}
            >
                <div className="space-y-1">
                    <div className="w-6 h-[3px] bg-white"></div>
                    <div className="w-6 h-[3px] bg-white"></div>
                    <div className="w-6 h-[3px] bg-white"></div>
                </div>
            </button>

            {/* Mobile Menu */}
            {open && (
                <div className="absolute top-[10vh] left-0 w-full bg-black/90 text-white py-6 flex flex-col items-center space-y-6 md:hidden z-50">

                    <a href="#landingPage" onClick={() => setOpen(false)}>
                        <span className="hover-underline-animation text-lg">Home</span>
                    </a>

                    <a href="#Aboutus" onClick={() => setOpen(false)}>
                        <span className="hover-underline-animation text-lg">About</span>
                    </a>

                    <a href="#Service" onClick={() => setOpen(false)}>
                        <span className="hover-underline-animation text-lg">Services</span>
                    </a>

                    <a href="#blogs" onClick={() => setOpen(false)}>
                        <span className="hover-underline-animation text-lg">Blogs</span>
                    </a>
                </div>
            )}
        </div>
    );
};

export default NavBar;
